import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=929bc0fc&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=ts&"
export * from "./orderList.vue?vue&type=script&lang=ts&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=929bc0fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929bc0fc",
  null
  
)

export default component.exports